import { useContext, useState } from "react";
import { useCrate } from "../../stores/useCrate";
import { useProfile } from "../../stores/useProfile";
import { StyledCrateList } from "./CrateList.styled";
import { Crate } from "../../models/Crate";
import {
  Box,
  IconButton,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";
import { CubeIcon, DresserIcon, PlusIcon, RectangleDashedIcon, ToolboxIcon, Tray, TrayIcon } from "@phosphor-icons/react";
import { LanguageContext } from "../../globals/LanguageContext";
import { useMessage } from "../messagePoppup/MessageContext";
import { useCrateType } from "../../hooks/useCrateType";

export const CrateList = () => {
  const [crates, setCrates] = useState<Crate[]>([]);
  const [selectedCrateType, setSelectedCrateType] = useState("11");
  const { fetchCrates, addCrate } = useCrate();
  const { user } = useProfile();
  const {showMessage} = useMessage();
  const { dictionary } = useContext(LanguageContext);
  const {CrateTypes} = useCrateType();
  

  const UpdateItems = async () => {
    if (!user) return;
    const res = await fetchCrates(user);
    if (res) setCrates(res);
  };

  const handleCreate = async () => {
    if (!user) return;
    
    const res = await addCrate(user, selectedCrateType);
    showMessage({statusCode: res})
    UpdateItems();
  }

  return (
    <StyledCrateList>
      <Box className="addCrate">
        <ToggleButtonGroup
          value={selectedCrateType}
          exclusive
          onChange={(_, newValue) => setSelectedCrateType(newValue)}
          className="buttongroup">
          {CrateTypes!.map((crateType) => (
            <ToggleButton className="button" value={crateType.value}>{crateType.icon}<Typography variant="h4">{crateType.text}</Typography>
            </ToggleButton>
          ))}
        </ToggleButtonGroup>
        <Box className="addbtn"><IconButton onClick={handleCreate}><PlusIcon size={64}/></IconButton></Box>
      </Box>
      <Box className="crateList">{crates.map((crate) => (<>{crate.code}</>))}</Box>
    </StyledCrateList>
  );
};
